export default __webpack_public_path__ + "static/media/attachmentHover.ce59abd2.svg";